const listeners = new Set();

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function dispatch(event) {
  listeners.forEach(fn => fn(event));
}
